import { render, staticRenderFns } from "./item-header.vue?vue&type=template&id=04daffca&scoped=true&"
import script from "./item-header.vue?vue&type=script&lang=js&"
export * from "./item-header.vue?vue&type=script&lang=js&"
import style0 from "./item-header.vue?vue&type=style&index=0&id=04daffca&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04daffca",
  null
  
)

export default component.exports